import React from 'react';
import type { ViewProps } from 'react-native';

import {
  ChallengesScreenContentSignedIn,
  ChallengesScreenContentSignedOut,
  ChallengesScreenLoading,
} from './subcomponents';

// ────────────────────────────────────────────────────────────────────────────────

export const ChallengesScreenContent = ({
  testID,
  isLoading,
  isSignedIn,
  onPressSignIn,
}: ChallengesScreenContentProps) => {
  if (isLoading) {
    return <ChallengesScreenLoading testID={testID?.concat('.loading')} />;
  }

  return isSignedIn ? (
    <ChallengesScreenContentSignedIn testID={testID} />
  ) : (
    <ChallengesScreenContentSignedOut
      testID={testID?.concat('.signed-out')}
      onPressSignIn={onPressSignIn}
    />
  );
};

type ChallengesScreenContentProps = {
  readonly isLoading: boolean;
  readonly isSignedIn: boolean;
} & Pick<
  React.ComponentProps<typeof ChallengesScreenContentSignedOut>,
  'onPressSignIn'
> &
  Pick<ViewProps, 'testID'>;
